<template>
  <div @mouseleave="onMouseLeave" @mouseover="onMouseOver">
    <el-row style="font-size: 1.1rem;height: 33px;">
      <el-col :span="19">
        {{ data.name }}
      </el-col>
    </el-row>
    <div style="padding: 25px 20px;">
      <el-row>
        <span>
          <span>
            <el-row>
              <el-col :span="5">额定功率：</el-col>
              <el-col :span="19">{{ data.ratedPower }} KW</el-col>
            </el-row>
            <el-row style="margin-top: 15px;height: 200px;overflow-y: auto">
              <!-- 功率-->
              <div v-if="data.equipmentCabinetDetails.power!==null && data.equipmentCabinetDetails.power!==''">
                <el-col :span="24" style="margin-bottom: 10px">
                  功率：
                </el-col>
                <el-col :span="24" style="margin-bottom: 20px">
                  <el-table :data="data.equipmentCabinetDetails.power" border style="width: 100%;color: #999999">
                      <el-table-column prop="deviceName" label="设备名称"></el-table-column>
                      <el-table-column prop="pointName" label="设备测点"></el-table-column>
                  </el-table>
                </el-col>
              </div>
              <!-- A路电流 -->
              <div v-if="data.equipmentCabinetDetails.aelec!==null && data.equipmentCabinetDetails.aelec!==''">
                <el-col :span="24" style="margin-bottom: 10px">
                  A路电流：
                </el-col>
                <el-col :span="24" style="margin-bottom: 20px">
                  <el-table :data="data.equipmentCabinetDetails.aelec" border style="width: 100%;color: #999999">
                      <el-table-column prop="deviceName" label="设备名称"></el-table-column>
                      <el-table-column prop="pointName" label="设备测点"></el-table-column>
                  </el-table>
                </el-col>
              </div>
              <!--  B路电流-->
              <div v-if="data.equipmentCabinetDetails.belec!==null && data.equipmentCabinetDetails.belec!==''">
                <el-col :span="24" style="margin-bottom: 10px">
                  B路电流：
                </el-col>
                <el-col :span="24" style="margin-bottom: 20px">
                  <el-table :data="data.equipmentCabinetDetails.belec" border style="width: 100%;color: #999999">
                      <el-table-column prop="deviceName" label="设备名称"></el-table-column>
                      <el-table-column prop="pointName" label="设备测点"></el-table-column>
                  </el-table>
                </el-col>
              </div>
              <!--  能耗-->
              <div v-if="data.equipmentCabinetDetails.energy!==null && data.equipmentCabinetDetails.energy!==''">
                <el-col :span="24" style="margin-bottom: 10px">
                  能耗：
                </el-col>
                <el-col :span="24" style="margin-bottom: 20px">
                  <el-table :data="data.equipmentCabinetDetails.energy" border style="width: 100%;color: #999999">
                      <el-table-column prop="deviceName" label="设备名称"></el-table-column>
                      <el-table-column prop="pointName" label="设备测点"></el-table-column>
                  </el-table>
                </el-col>
              </div>
            </el-row>
          </span>
        </span>
      </el-row>
      <el-row>
        <el-col :span="6" class="btn-content">
          <img @touchstart="() => editData(data)" @click="() => editData(data)" alt="编辑" class="hidden btn btn-edit" ref="btnEdit"
               src="@/assets/images/icon/edit.png"
               v-show="showBtn">
          <img @touchstart="() => deleteData(data.id)"  @click="() => deleteData(data.id)" alt="删除" class="hidden btn btn-delete" ref="btnDelete"
               src="@/assets/images/icon/delete.png"
               v-show="showBtn">
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

import {delCabinetById} from "@/network/cabinet-manage";

export default {
  name: "cabinetCard",
  data() {
    return {
      showBtn: false,
      data: this.cabinetList,
      // 设备信息表格
      deviceInfoTable: []
    }
  },
  props: {
    cabinetList: {
      type: Object,
      default: () => {
      },
    }
  },
  watch: {
    cabinetList: {
      handler(newPassword) {
        this.data = newPassword;
      }
    }
  },
  mounted() {
  },
  methods: {
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    //删除机柜信息
    deleteData(id) {
      this.$confirm('是否确认删除', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            delCabinetById(id).then(res => {
              if (res.code === 0) {
                this.$message.success("删除成功!")
                this.$emit('cabinetPage', {pageCurrent: 1, pageSize: 999})
              } else {
                this.$message.error("删除失败!")
              }
            })
          }
        }
      })
    },
    //编辑机柜
    editData(data) {
      this.$emit("openDialog", "edit", data)
    },
  }
}
</script>

<style scoped>
.btn-content {
  float: right;
}
</style>
